import { ChangeDetectionStrategy, Component, HostBinding, Input, TemplateRef, ViewChild } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { PropType } from '@frontend/sports/common/core/utils/extended-types';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetBuilderTrackingValues } from '../../bet-builder-tracking';
import { BetBuilderOverlayService } from '../../services/bet-builder-overlay.service';
import { BetBuilderOverlayHeaderComponent } from '../bet-builder-overlay-header/bet-builder-overlay-header.component';

@Component({
    selector: 'ms-betbuilder-overlay-trigger-banner',
    templateUrl: './overlay-trigger-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BetBuilderOverlayHeaderComponent],
})
export class OverlayTriggerBannerComponent {
    @HostBinding('class') className = 'betbuilder-overlay-trigger';

    @Input() event: EventModel;
    @ViewChild('header') headerTemplate: TemplateRef<any>;

    betbuilderMessages: PropType<PropType<Sitecore, 'betBuilderEntainUI'>, 'messages'>;

    constructor(
        sitecore: Sitecore,
        private betBuilderOverlayService: BetBuilderOverlayService,
        private tracker: TrackingService,
    ) {
        this.betbuilderMessages = sitecore.betBuilderEntainUI.messages;
    }

    openBuilder() {
        this.tracker.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: BetBuilderTrackingValues.BetBuilder,
            [trackingConstants.COMPONENT_LABEL_EVENT]: BetBuilderTrackingValues.BuildaBetPod,
            [trackingConstants.COMPONENT_ACTION_EVENT]: BetBuilderTrackingValues.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: BetBuilderTrackingValues.Tab,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: this.event.name,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: BetBuilderTrackingValues.BuildaBet,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.SPORT_ID]: this.event.sport.id.toString(),
            [trackingConstants.SPORT_LEAGUE_ID]: this.event.league.id.toString(),
        });
        this.betBuilderOverlayService.openBuilder({
            headerTemplate: this.headerTemplate,
            event: this.event,
            isOverlay: true,
            source: BetBuilderTrackingValues.MarketBoardButton,
        });
    }
}
